import { reveal } from "@/lib/reveal";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, BookOpenCheck, Compass, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

const principles = [
  {
    icon: Compass,
    title: "Meerdere bronnen",
    text: "Een leerlingbeeld ontstaat uit opdrachten, reflecties, ervaringen, gesprekken en waar relevant vragenlijsten.",
  },
  {
    icon: BookOpenCheck,
    title: "Transparante methodiek",
    text: "We leggen uit welke modellen en informatie worden gebruikt, zonder een uitkomst als absolute waarheid te presenteren.",
  },
  {
    icon: MessageCircle,
    title: "Menselijke beoordeling",
    text: "Technologie ondersteunt het proces. De leerling, mentor en decaan geven samen betekenis aan de uitkomsten.",
  },
];

const SocialProofSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 lg:py-32 animate-on-scroll overflow-hidden">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid lg:grid-cols-[1.5fr_1fr] gap-8 items-end mb-14">
          <div>
            <span className="inline-block text-[11px] font-bold tracking-[0.2em] uppercase text-primary mb-4 px-3 py-1 bg-accent rounded-full">
              Zorgvuldig onderbouwd
            </span>
            <h2 className="text-3xl lg:text-[2.6rem] font-extrabold text-foreground leading-[1.1]">
              Duidelijk over wat inzicht geeft — en wat niet.
            </h2>
          </div>
          <div className="lg:text-right lg:pb-1">
            <Button
              variant="outline"
              className="rounded-full font-semibold gap-2"
              onClick={() => navigate("/onderbouwing")}
            >
               Bekijk methodiek &amp; privacy <ArrowRight className="w-4 h-4" />
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
            {principles.map((principle, i) => (
              <motion.div
                key={principle.title}
                initial={reveal({ opacity: 0, y: 30 })}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.15 * (i + 1) }}
                viewport={{ once: true }}
                className={`rounded-3xl p-7 flex flex-col justify-center ${i === 0 ? "bg-primary text-primary-foreground" : "bg-card border border-border"}`}
              >
                <principle.icon className={`mb-5 h-7 w-7 ${i === 0 ? "text-primary-foreground" : "text-primary"}`} />
                <h3 className={`text-lg font-extrabold ${i === 0 ? "text-primary-foreground" : "text-secondary"}`}>{principle.title}</h3>
                <p className={`mt-3 text-sm leading-relaxed ${i === 0 ? "text-primary-foreground/80" : "text-muted-foreground"}`}>{principle.text}</p>
              </motion.div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
